import React, { useState, ReactElement } from 'react';
import NotificationCard from './NotificationCard';
import ChevronDown from 'icons/indexed-icons/ChevronDown';
import ChevronRight from 'icons/indexed-icons/ChevronRight';
import {
  AccordionContainer,
  AccordionHeader,
  AccordionContent,
  DashedLine
} from './index.elements';
import NoNotifications from './NoNotifications';
import { CartPriceChangeAlert } from 'types/machine-health/alerts';

interface AccordionProps {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement | Array<any>;
  isOpenInitially?: boolean;
  isAlternative?: boolean;
  updateNotificationStatus?: (id: string) => void;
  deleteNotification?: (id?: string) => void;
  showNotificationDetails?: (type: string, customData?: CartPriceChangeAlert) => void;
}

const Accordion = ({
  title,
  children,
  isOpenInitially = false,
  isAlternative,
  updateNotificationStatus,
  deleteNotification,
  showNotificationDetails
}: AccordionProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(isOpenInitially);

  return (
    <AccordionContainer>
      <AccordionHeader onClick={() => setIsOpen(!isOpen)}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <span className="icons" style={{ marginRight: '0.5rem' }}>
            {isOpen ? <ChevronDown height="12px" width="12px" /> : <ChevronRight />}
          </span>
          <span style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            {title}
            <DashedLine />
          </span>
        </div>
      </AccordionHeader>
      {isOpen && (
        <AccordionContent>
          {children && children.length > 0 ? (
            children.map((notification) => (
              <NotificationCard
                key={notification.id}
                data={notification}
                isAlternative={isAlternative}
                updateNotificationStatus={updateNotificationStatus}
                deleteNotification={deleteNotification}
                showNotificationDetails={showNotificationDetails}
              />
            ))
          ) : (
            <NoNotifications />
          )}
        </AccordionContent>
      )}
    </AccordionContainer>
  );
};

export default Accordion;
